import {
  PROMO_CHANGE_VALUE,
  PROMO_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';
import apiClient from '@shared/lib/general/apiClient';
import _ from 'lodash';

const actions = {
  changePromoValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: PROMO_CHANGE_VALUE,
      field,
      value,
    });
  },
  changePromoValues({ commit }, payload) {
    commit({
      type: PROMO_CHANGE_VALUES,
      changes: payload,
    });
  },
  async getPromos({ commit }, corpId) {
    const { data } = await apiClient({
      method: 'GET',
      url: `/promos/${corpId}/all`,
    });
    commit({
      type: PROMO_CHANGE_VALUE,
      field: 'promos',
      value: data,
    });
  },
  async createPromo({ commit, state }, payload) {
    const {
      promos,
    } = state;
    const {
      promo,
      backgroundImage,
      backgroundImageName,
      mainImage,
      mainImageName,
    } = payload;

    const formData = new FormData();
    formData.append('promo', JSON.stringify(promo));
    if (backgroundImage) {
      formData.append('backgroundImage', backgroundImage);
      formData.append('backgroundImageName', backgroundImageName);
    }
    if (mainImage) {
      formData.append('mainImage', mainImage);
      formData.append('mainImageName', mainImageName);
    }

    const { data } = await apiClient({
      method: 'POST',
      url: '/promos/new',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const newPromos = [
      data,
      ...promos,
    ];
    commit({
      type: PROMO_CHANGE_VALUE,
      field: 'promos',
      value: newPromos,
    });
  },
  async updatePromo({ commit, state }, payload) {
    const {
      promos,
    } = state;
    const {
      promo,
      backgroundImage,
      backgroundImageName,
      mainImage,
      mainImageName,
    } = payload;

    const formData = new FormData();
    formData.append('promo', JSON.stringify(promo));
    if (backgroundImage) {
      formData.append('backgroundImage', backgroundImage);
      formData.append('backgroundImageName', backgroundImageName);
    }
    if (mainImage) {
      formData.append('mainImage', mainImage);
      formData.append('mainImageName', mainImageName);
    }

    const { data } = await apiClient({
      method: 'POST',
      url: `/promos/${promo.id}/update`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const newPromos = promos.map((p) => {
      if (p.id === promo.id) {
        return data;
      }
      return p;
    });
    commit({
      type: PROMO_CHANGE_VALUE,
      field: 'promos',
      value: newPromos,
    });
  },
  async getPotensialUsers({ commit, state }, planId) {
    const {
      potentialUsers,
    } = state;
    const pu = _.cloneDeep(potentialUsers ?? []);
    const { data } = await apiClient({
      method: 'GET',
      url: `/promos/potentialMembers/${planId}`,
    });
    if (!pu.find((x) => x.planId === planId)) {
      pu.push({ planId, count: data });
    }
    commit({
      type: PROMO_CHANGE_VALUE,
      field: 'potentialUsers',
      value: pu,
    });
  },
  async deletePromo({ commit, state }, promoId) {
    const {
      promos,
    } = state;
    await apiClient({
      method: 'DELETE',
      url: `/promos/${promoId}/delete`,
    });
    const newPromos = promos.filter((pro) => pro.id !== promoId);
    commit({
      type: PROMO_CHANGE_VALUE,
      field: 'promos',
      value: newPromos,
    });
  },
};
export default actions;
